import Vue from 'vue';
import VueRouter from 'vue-router';
import vSelect from 'vue-select';
import vbclass from 'vue-body-class';
import VTooltip from 'v-tooltip';
import VueTelInput from 'vue-tel-input';

import router from './router';
import { i18n } from '../app/i18n';

import App from './components/App.vue';
import Swal from '../shared/plugins/swal';

Vue.component('v-select', vSelect);

Vue.use(VueRouter);
Vue.use(Swal);
Vue.use(VTooltip);
Vue.use(VueTelInput);

const app = new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#devise_app');

Vue.use(vbclass, router);

export default app;
